import { atom } from 'recoil';

export const filtersState = atom({
  key: 'filtersState',
  default: {
    marks: null,
    cities: null,
    transmissions: null,
    dwhells: null,
    engineTypes: null,
    carsBodies: null,
  },
});

export const savedFiltersState = atom({
  key: 'savedFiltersState',
  default: null,
});

export const filterIndexState = atom({
  key: 'filterIndexState',
  default: 0,
});

export const filterOptionsState = atom({
  key: 'filterOptionsState',
  default: {
    savedSearchId: null,
    engineType: [],
    transmissions: [],
    publishedDateFrom: null,
    publishedDateTo: null,
    mileageFrom: null,
    mileageTo: null,
    dwhells: [],
    carsBodies: [],
    cities: [],
    maxOwnersNumber: null,
    priceFrom: null,
    priceTo: null,
    engineCapacityFrom: null,
    engineCapacityTo: null,
  },
});

export const subjectsStateAtom = atom({
  key: 'subjectsState',
  default: [
    {
      marka: null,
      models: null,
      yearFrom: null,
      yearTo: null,
    },
  ],
});

export const subjectsStateSelector = atom({
  key: 'subjectsStateSelector',
  get: ({ get }) => {
    return get(subjectsStateAtom);
  },
});

export const subjectsCountAtom = atom({
  key: 'subjectsCountAtom',
  default: 1,
});

export const hasWorkListState = atom({
  key: 'hasWorkListState',
  default: true,
});

export const paginationIndexAtom = atom({
  key: 'paginationIndex',
  default: 0,
});

export const newsAtom = atom({
  key: 'news',
  default: null,
});

// export const likesAtom = atom({
//   key: 'likes',
//   default: null,
// });

export const usersAtom = atom({
  key: 'usersAtom',
  default: null,
});

export const branchesAtom = atom({
  key: 'branchesAtom',
  default: null,
});
